import { render } from "./RecommendFoodMenuItem.vue?vue&type=template&id=30f72cf9&scoped=true&ts=true"
import script from "./RecommendFoodMenuItem.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodMenuItem.vue?vue&type=script&lang=ts"

import "./RecommendFoodMenuItem.vue?vue&type=style&index=0&id=30f72cf9&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f72cf9"]])

export default __exports__